import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'last_trade_timestamp', label: 'last_trade_timestamp' },
  { id: 'zerion_last_enriched_at', label: 'zerion_last_enriched_at' },
  { id: 'portfolio_total_usd', label: 'portfolio_total_usd' },
  { id: 'portfolio_cash_usd', label: 'portfolio_cash_usd' },
  { id: 'portfolio_fungibles_usd', label: 'portfolio_fungibles_usd' },
  { id: 'portfolio_nfts_usd', label: 'portfolio_nfts_usd' },
  { id: 'pnl_pct_total', label: 'pnl_pct_total' },
  { id: 'pnl_net_invested_usd', label: 'pnl_net_invested_usd' },
  { id: 'pnl_realized_usd', label: 'pnl_realized_usd' },
  { id: 'pnl_unrealized_usd', label: 'pnl_unrealized_usd' },
  { id: 'volume_usd_24h', label: 'volume_usd_24h' },
  { id: 'volume_usd_7d', label: 'volume_usd_7d' },
  { id: 'volume_usd_30d', label: 'volume_usd_30d' },
  { id: 'num_trades_24h', label: 'num_trades_24h' },
  { id: 'num_trades_30d', label: 'num_trades_30d' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'Wallet / Chain / Labels / Tags' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'author_in_app_users', label: 'In-App Users (your pushed wallets)' },
];

const WalletUsersQuery = () => {
  return (
    <QueryModes
      source="wallet-users"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default WalletUsersQuery;
